<!--
  TIENDAS DE UN COMERCIO — pantalla propia, a todo el ancho.
  Superficie plana: `.kb-seccion` y `.kb-tabla-plana`, sin tarjeta alrededor.

  Lo que salió de la pestaña vieja, y por qué:
    · el subtítulo «Los puntos de venta donde este comercio opera…» — lo que
      decía de verdad («un comercio sin tiendas todavía no puede vender») ya
      está en el vacío, que es donde hace falta leerlo;
    · el modal de ver una tienda — 55 líneas MUERTAS: `tiendaVista` no se
      asignaba nunca desde que abrir una tienda pasó a ser navegar;
    · el modal de «Agregar una tienda» — ahora es `…/tiendas/nueva`.
-->
<!-- 🔴 SIN MIGA, SIN TÍTULO Y SIN ENVOLTORIO DE PÁGINA — 2026-09-20.
     Esta pantalla es una RUTA HIJA de la ficha del comercio y se dibuja dentro
     de su `<router-outlet>`. El padre ya pone la miga, el nombre del comercio,
     su estado, la tira del portal y la barra de pestañas: repetirlos acá los
     mostraba DOS VECES, uno debajo del otro, y además `kb-page` anidado dentro
     de `kb-page` duplicaba el relleno y el ancho máximo.
     Lo que sí queda acá son las ACCIONES de esta pantalla. -->
<div class="space-y-8">


  <!-- ══ Encabezado ═══════════════════════════════════════════════════════════ -->
  <!-- 🔴 LAS ACCIONES, A LA DERECHA Y CON AIRE. Juan, 2026-09-20: «el botón,
       cuando navegas entre pestañas, está a la izquierda y pegado».
       Era `kb-page-header`, que reparte título a la izquierda y acciones a la
       derecha con `justify-between`. Al sacarle el título —lo pone el padre—
       quedó UN SOLO hijo, y `justify-between` con uno solo lo manda al borde
       izquierdo. Acá se alinea a la derecha a propósito, y `pt-1` lo despega de
       la barra de pestañas de arriba. -->
  <div class="flex flex-wrap items-center justify-end gap-2 pt-2">

    <div class="flex shrink-0 flex-wrap items-center gap-2" *ngIf="!cargando && !noEncontrado">
      <!-- 2026-09-24: sin tiendas, el botón vive en el aviso vacío de abajo; éste lo repetía. -->
      <button type="button" class="kb-btn kb-btn-primary" *ngIf="puedeCrear() && tiendas.length" (click)="irAlAlta()">
        <i class="fas fa-plus" aria-hidden="true"></i>Agregar una tienda
      </button>
    </div>
  </div>

  <!-- ══ Cargando ═════════════════════════════════════════════════════════════ -->
  <!-- El esqueleto conserva la FORMA de lo que viene: un renglón de filtro y la
       tabla. Con otra silueta, la pantalla salta al cargar. -->
  <div *ngIf="cargando" class="space-y-4" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-9 w-full max-w-xl"></div>
    <div class="kb-skeleton h-64 w-full"></div>
  </div>

  <!-- ══ No existe el comercio ════════════════════════════════════════════════ -->
  <div class="kb-empty" *ngIf="!cargando && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-store-slash" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
    <p class="kb-empty-texto">Puede que el código esté mal escrito.</p>
    <a class="kb-btn kb-btn-outline mt-4" [routerLink]="['/console/merchants']">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a comercios
    </a>
  </div>

  <ng-container *ngIf="!cargando && !noEncontrado">

    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Puntos de venta</h2>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <!-- ── Buscador y conteo ─────────────────────────────────────────────────
           📍 El buscador ocupa el ancho que tiene: con 89 tiendas es la
           herramienta principal de esta pantalla, no un adorno al costado. -->
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
           *ngIf="tiendas.length">
        <div class="flex w-full items-center gap-2 md:max-w-xl">
          <div class="kb-buscador w-full">
            <label class="sr-only" for="buscarTienda">Buscar tienda</label>
            <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
            <input id="buscarTienda" type="text" class="kb-input kb-input-icono w-full"
                   placeholder="Buscar por código, nombre o ciudad"
                   [(ngModel)]="busqueda" (ngModelChange)="alEscribir()">
          </div>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm shrink-0" *ngIf="busqueda"
                  (click)="limpiarBusqueda()">
            <i class="fas fa-times" aria-hidden="true"></i>Limpiar la búsqueda
          </button>
        </div>

        <p class="shrink-0 text-sm text-muted-foreground">
          <span class="tabular-nums">{{ tiendasFiltradas.length }}</span>
          {{ tiendasFiltradas.length === 1 ? 'tienda' : 'tiendas' }}<span
            *ngIf="busqueda && tiendasFiltradas.length !== tiendas.length">
            de <span class="tabular-nums">{{ tiendas.length }}</span></span><span
            *ngIf="!busqueda && inhabilitadas">
            &middot; <span class="tabular-nums">{{ inhabilitadas }}</span> {{ inhabilitadas === 1 ? 'inhabilitada' : 'inhabilitadas' }}</span>
        </p>
      </div>

      <!-- ── La tabla, a la vista ──────────────────────────────────────────── -->
      <div class="kb-tabla-plana" *ngIf="tiendasPaginadas.length">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th kb-th-orden" (click)="ordenarPor('code')">
                Código <i class="fas kb-icono-fila" [ngClass]="iconoOrden('code')" aria-hidden="true"></i>
              </th>
              <th class="kb-th kb-th-orden" (click)="ordenarPor('name')">
                Tienda <i class="fas kb-icono-fila" [ngClass]="iconoOrden('name')" aria-hidden="true"></i>
              </th>
              <!-- 🔴 2026-09-25: la ciudad es un campo nuevo; con ninguna tienda cargada, la columna
                   entera decía «—» y no informaba nada. Aparece cuando alguna la tenga. -->
              <th class="kb-th kb-th-orden" *ngIf="hayCiudades" (click)="ordenarPor('city')">
                Ciudad <i class="fas kb-icono-fila" [ngClass]="iconoOrden('city')" aria-hidden="true"></i>
              </th>
              <th class="kb-th">Estado</th>
              <th class="kb-th kb-th-acciones">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <!-- 🔴 La FILA ENTERA abre la tienda, no sólo el ojito: el nombre y el
                 código son lo que la gente intenta tocar primero, y en una tabla
                 de 89 filas apuntarle a un ícono de 16 píxeles es trabajo.
                 Con teclado: Tab la enfoca y Enter la abre. -->
            <tr class="kb-tr kb-tr-clic focus:outline-none focus-visible:bg-accent
                       focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring/40"
                *ngFor="let t of tiendasPaginadas; trackBy: porCodigo"
                tabindex="0" role="button"
                [attr.aria-label]="'Abrir la tienda ' + (t.name || t.code)"
                (click)="verTienda(t)" (keydown.enter)="verTienda(t)">
              <td class="kb-td kb-td-mono">{{ t.code }}</td>
              <td class="kb-td">
                <span class="kb-td-titulo">{{ t.name || t.short_name || '—' }}</span>
                <p class="kb-td-sub" *ngIf="t.short_name && t.name && t.short_name !== t.name">
                  {{ t.short_name }}
                </p>
              </td>
              <td class="kb-td" *ngIf="hayCiudades">{{ t.city || '—' }}</td>
              <td class="kb-td">
                <span class="kb-badge kb-badge-exito" *ngIf="t.status !== false">
                  <i class="fas fa-check-circle" aria-hidden="true"></i>Activa
                </span>
                <span class="kb-badge kb-badge-neutro" *ngIf="t.status === false">
                  <i class="fas fa-ban" aria-hidden="true"></i>Inactiva
                </span>
              </td>
              <td class="kb-td-acciones">
                <div class="kb-acciones-grupo">
                  <!-- 📍 El ícono dice lo que va a PASAR, no el estado actual: en
                       una tienda activa se ve el de apagar.
                       ⚠️ `stopPropagation`: sin eso, apagar una tienda además
                       abriría su ficha, y el clic haría dos cosas. -->
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon"
                          *ngIf="puedeEditar()"
                          (click)="$event.stopPropagation(); alternarTienda(t)"
                          [attr.aria-label]="t.status !== false ? 'Inhabilitar esta tienda' : 'Volver a habilitarla'"
                          [title]="t.status !== false ? 'Inhabilitar esta tienda' : 'Volver a habilitarla'">
                    <i class="fas" [ngClass]="t.status !== false ? 'fa-toggle-on' : 'fa-toggle-off'"
                       aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Paginación: adentro del mismo recuadro, al pie de la tabla. -->
        <div class="kb-pager" *ngIf="totalPaginas > 1">
          <p class="kb-barra-nota">
            Página <span class="tabular-nums">{{ pagina }}</span> de
            <span class="tabular-nums">{{ totalPaginas }}</span>
          </p>
          <div class="flex items-center gap-1">
            <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                    [disabled]="pagina === 1" (click)="irAPagina(pagina - 1)"
                    aria-label="Página anterior">
              <i class="fas fa-chevron-left" aria-hidden="true"></i>
            </button>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                    [disabled]="pagina === totalPaginas" (click)="irAPagina(pagina + 1)"
                    aria-label="Página siguiente">
              <i class="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Vacíos: «no tiene» y «no encontró» no son lo mismo. -->
      <div class="kb-empty" *ngIf="!tiendas.length">
        <span class="kb-empty-icono"><i class="fas fa-store" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Sin tiendas asignadas</p>
        <p class="kb-empty-texto">Un comercio sin tiendas todavía no puede vender.</p>
        <button type="button" class="kb-btn kb-btn-primary mt-4" *ngIf="puedeCrear()"
                (click)="irAlAlta()">
          <i class="fas fa-plus" aria-hidden="true"></i>Agregar una tienda
        </button>
      </div>
      <div class="kb-empty" *ngIf="tiendas.length && !tiendasFiltradas.length">
        <span class="kb-empty-icono"><i class="fas fa-search" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Ninguna tienda coincide con «{{ busqueda }}»</p>
        <button type="button" class="kb-btn kb-btn-outline mt-4" (click)="limpiarBusqueda()">
          Limpiar la búsqueda
        </button>
      </div>
      </div>
    </section>

  </ng-container>
</div>
